import { Chat } from '../chatbot/chat/chat';
import { IBilling, IChat, IChatInfo, ISaveChat } from '../chatbot/api/llmapi';
import { Conversation } from './conversation';
import { SaveDialog } from '../dialogs/savedialog';
import { Util } from './util';

export class Chats
{
    static async deleteChat(chatInfo : IChatInfo) 
    {
        await Conversation.api.deleteChat!(chatInfo.id);
    }

    static async getChats() : Promise<IChatInfo[]>
    {
        if (Conversation.listOfChats === undefined) {
            Conversation.listOfChats = await Conversation.api.list!();
        }

        return Conversation.listOfChats;
    }

    static async loadChat(chatInfo : IChatInfo)
    {
        const reply : IChat = await Conversation.api.loadChat!(chatInfo);
        const chat  : Chat  = Chat.load(reply);

        Conversation.setChat(chat);
    }

    static async refreshChats() : Promise<IChatInfo[]>
    {
        Conversation.listOfChats = await Conversation.api.list!();
        return Conversation.listOfChats;
    }

    static async saveChat(saveAsNew : boolean) : Promise<string>
    {
        if (Conversation.chat === undefined) {
            return "";
        }

        const chat = Conversation.chat!;

        chat.name = await SaveDialog.showSaveDialog(chat.name, saveAsNew);

        const saveChat : ISaveChat = {
            name : chat.name,
            tree : chat.getTree()
        };

        if (!saveAsNew) {
            saveChat.id = chat.id;
        }

        chat.id = await Conversation.api.save!(saveChat);
        return chat.id;
    }

    static async getBills(start: Date, end: Date): Promise<IBilling[]>
    {
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);
        Conversation.bills.start = start;
        Conversation.bills.end = end;
        Conversation.bills.bills = await Conversation.api.getBilling!(Util.getDateTimeFormatted(start), Util.getDateTimeFormatted(end));

        return Conversation.bills.bills;
    }
}

